import React, { useEffect, useState } from 'react';
import styles from '../styles/Preloader.module.scss';
const base = process.env.PUBLIC_URL || ``;


interface PreloaderProps {
    resources: string[];
    onLoaded: () => void;
}

export const Preloader: React.FC<PreloaderProps> = ({ resources, onLoaded }) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        let loaded = 0;
        const total = resources.length;

        const updateProgress = () => {
            loaded += 1;
            setProgress(Math.round((loaded / total) * 100));
            if (loaded === total) {
                // @ts-ignore
                setTimeout(onLoaded, 500); // небольшая задержка для плавности
            }
        };

        resources.forEach((url) => {
            if (url.match(/\.(mp3|wav|ogg)$/)) {
                const audio = new Audio();
                audio.src = url;
                audio.oncanplaythrough = updateProgress;
                audio.onerror = updateProgress;
            } else {
                const img = new window.Image();
                img.src = url;
                img.onload = updateProgress;
                img.onerror = updateProgress;
            }
        });
        // eslint-disable-next-line
    }, [resources]);

    return (
        <div className={styles.preloader}>
            <img src={`${base}/images/blur.jpg`} className={styles.preloaderBg} alt="Preloader" />
            <div className={styles.progressBar}>
                <div
                    className={styles.progressFill}
                    style={{ width: `${progress}%` }}
                />
            </div>
            <div className={styles.text}>{progress}%</div>
        </div>
    );
};
